import { COLOR_KEYS } from '../../constants';
export const oneColumnBlockConfig = {
    name: 'OneColumnBlock',
    image: 'https://cdn.zapier.com/storage/photos/90baf19765445a2c227021419c5dc925.png',
    includeScrollTracking: true,
    category: 'Zapier Sections',
    inputs: [
        {
            name: 'background',
            type: 'string',
            enum: [
                COLOR_KEYS.lava10,
                COLOR_KEYS.ocean10,
                COLOR_KEYS.sun10,
                COLOR_KEYS.white,
                // V5 Colors
                COLOR_KEYS.blue10,
                COLOR_KEYS.cream,
                COLOR_KEYS.neutral100,
                COLOR_KEYS.neutral200,
            ],
            defaultValue: 'neutral100',
        },
        {
            name: 'textAlign',
            type: 'string',
            enum: ['left', 'right', 'center', 'inherit'],
            defaultValue: 'center',
        },
        {
            name: 'heading',
            type: 'string',
            defaultValue: 'This is a default heading (Edit me)',
        },
        {
            name: 'headingTag',
            helperText: 'HTML heading level for heading.',
            type: 'string',
            enum: ['h1', 'h2', 'h3'],
            defaultValue: 'h3',
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'imageUrl',
            type: 'cloudinaryImage',
        },
        {
            name: 'altText',
            type: 'string',
        },
    ],
};
//# sourceMappingURL=config.js.map